import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { HttpHandler } from 'app/shared/http/http-handler';
import { NotificationService } from 'app/shared/services/notification.service';
import { AppConfigService } from 'app/shared/settings/app-config.service';
import { Subject } from 'rxjs';
import { CodigoPastaEnum } from './enum/codigo-pasta.enum';
import { UploadArquivoService } from './upload-arquivo.service';
@Component({
  selector: 'app-upload-arquivo',
  templateUrl: './upload-arquivo.component.html',
  styleUrls: ['./upload-arquivo.component.scss']
})
export class UploadArquivoComponent implements OnInit {

  dragArea = 'dragarea';

  arquivoAtual: any = null;
  tipoArquivoAtual = '';
  nomeArquivoAtual = '';

  erro: string = null;

  arquivosCarregando = false;
  listaArquivosCarregando: Array<any>;
  numeroArquivosCarregando = 0;

  listaArquivos = [];

  @Input() arquivoUnico = false;
  @Input() restricaoTipo: Array<string>;
  @Input() cdPasta: CodigoPastaEnum;
  @Input() cdAuxiliar: CodigoPastaEnum;

  @Output() emitUploadComplete = new EventEmitter<any>();

  private uploadService: UploadArquivoService;

  constructor(
    private cdRef: ChangeDetectorRef,
    private appSettings: AppConfigService,
    private notification: NotificationService,
    private http: HttpHandler,
  ) {

  }

  ngOnInit(): void {
    this.uploadService = new UploadArquivoService(this.appSettings, this.notification, this.http, this.cdPasta, this.cdAuxiliar)
  }

  salvarArquivos(files: FileList) {
    this.erro = null;
    if (this.arquivoUnico && files.length > 1) {
      this.erro = 'Somente um arquivo por vez.';
      return;
    } else if (files.length === 1) {
      if (!this.verificarRestricao(files[0].type)) {
        this.erro = 'Tipo de arquivo incompatível.'
        return;
      }
    } else if (files[0] == null) {
      return;
    }
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      const result = event.target.result;
      this.arquivosCarregando = true;

      if (this.arquivoUnico) {
        this.tipoArquivoAtual = files[0].type;
        this.nomeArquivoAtual = files[0].name;
        // this.salvarArquivoUnico(files[0]);
        this.arquivoAtual = result;
        files[0]['porcentagemEnvio'] = -1;
        this.listaArquivos.push(files[0])
        this.cdRef.detectChanges();
      } else {
        this.tipoArquivoAtual = files[0].type;
        this.nomeArquivoAtual = files[0].name;
        if (!this.listaArquivos) {
          this.listaArquivos = new Array<File>();
        }
        for (let i = 0; i < files.length; i++) {
          files[i]['porcentagemEnvio'] = -1;
          this.listaArquivos.push(files[i])
        }
        this.cdRef.detectChanges();
        // this.salvarArquivoLista(files);
      }
      console.log(this.listaArquivos)
    });
    reader.readAsDataURL(files[0]);
  }

  salvarArquivoUnico(file) {
    if (file['porcentagemEnvio'] == -1) {
      const progressoSubject = new Subject<any>();
      progressoSubject.subscribe({
        next: (progresso) => { this.atualizarProgresso(file.name, progresso.porcentagem) },
        complete: () => { }
      });
      let arquivoInfo: any;
      this.numeroArquivosCarregando++;
      this.uploadService.salvarDados(file, progressoSubject).then(res => {
        console.log('Arquivo Salvo' + res);
        this.emitUploadComplete.emit(arquivoInfo);
      })
    }
  }

  salvarArquivoLista(files) {
    const progressoSubject = new Subject<any>();
    progressoSubject.subscribe({
      next: (progresso) => { this.atualizarProgresso(progresso.arquivo, progresso.porcentagem) },
      complete: () => { }
    });

    for (let i = 0; i < files.length; i++) {
      if (files[i]['porcentagemEnvio'] == -1) {
        this.numeroArquivosCarregando++;
        this.uploadService.salvarDados(files[i], progressoSubject).then(res => {
          let arquivoInfo;
          this.emitUploadComplete.emit(arquivoInfo);
        });
      }
    }
  }
  atualizarProgresso(nomeArquivo: string, porcentagem: number) {
    if (porcentagem === 100) {
      this.numeroArquivosCarregando -= 1;
    }
    if (!this.listaArquivosCarregando) {
      this.listaArquivosCarregando = [];
    }
    const index = this.listaArquivosCarregando.findIndex(a => a.arquivo === nomeArquivo);
    if (index >= 0) {
      if (porcentagem > this.listaArquivosCarregando[index].porcentagem) {
        this.listaArquivosCarregando.splice(index, 1, Object.assign({ arquivo: nomeArquivo, porcentagem: porcentagem }));
      }
    } else {
      this.listaArquivosCarregando.push({ arquivo: nomeArquivo, porcentagem: porcentagem });
    }

    const arquivo = this.listaArquivos.find(e => e.name == nomeArquivo);
    arquivo['porcentagemEnvio'] = porcentagem;
    this.cdRef.detectChanges();
  }

  obterProgresso() {
    if (!this.listaArquivosCarregando) {
      this.listaArquivosCarregando = [];
    }
    const lista = this.listaArquivosCarregando.filter(e => { return e.porcentagem < 100 });
    if (lista.length === 0 && this.numeroArquivosCarregando === 0) {
      this.arquivosCarregando = false;
    }
    return lista;
  }

  verificarRestricao(tipo: string) {
    if (this.restricaoTipo != null && this.restricaoTipo.length > 0) {
      if (this.restricaoTipo.some(r => tipo.includes(r))) {
        return true;
      }
    } else {
      return true
    }
    return false;
  }

  removerListaArquivo(event: any, index: number) {
    event.stopPropagation();
    this.listaArquivos.splice(index, 1)
  }
  uploadIndividualArquivo(event: any, index: number) {
    event.stopPropagation();
    const arquivo = this.listaArquivos[index];
    this.salvarArquivoUnico(arquivo);
  }

  enviarTodosArquivos(event) {
    event.stopPropagation();
    this.salvarArquivoLista(this.listaArquivos);
  }

  limparCampo(event) {
    event.stopPropagation();
    this.arquivoAtual = null;
    this.nomeArquivoAtual = null;
    this.arquivosCarregando = false;
    this.listaArquivos = [];
  }

  clickDrop(event) {
    const element = event.target as HTMLInputElement
    element.value = ''
  }

  onFileChange(file: any) {
    const files: FileList = file.target.files;
    this.salvarArquivos(files);
    file.target.files = null;
  }

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    this.dragArea = 'droparea';
    event.preventDefault();
  }

  @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
    this.dragArea = 'droparea';
    event.preventDefault();
  }

  @HostListener('dragend', ['$event']) onDragEnd(event: any) {
    this.dragArea = 'dragarea';
    event.preventDefault();
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    this.dragArea = 'dragarea';
    event.preventDefault();
  }

  @HostListener('drop', ['$event']) onDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      const files: FileList = event.dataTransfer.files;
      this.salvarArquivos(files);
    }
    this.dragArea = 'dragarea';
  }
}

